import axios from 'axios';
import * as bootstrap from 'bootstrap';
import 'daterangepicker';
import Inputmask from 'inputmask';
import intlTelInput from 'intl-tel-input';
import $ from 'jquery';

var dateBirth = ''

$(function () {
	init()

	$('form[action*=verifyParticipant] #cpf').off('change.validate').on('change.validate', function () {
		const $cpf = $(this)

		if (this.inputmask?.isValid()) axios.post('verifyCpf', { cpf: this.value }).then(function ({ data: { exists } }) {
			$cpf.removeClass('is-valid is-invalid')
			$('.cpfIsValid').toggle(exists)
			$('#next').show()
			$('#isCpfValid').val(exists ? 1 : 0)
			$cpf.addClass('is-valid')
		}).catch(function (error) {
			$cpf.removeClass('is-valid is-invalid')
			console.log(error)
			$('#isCpfValid').val(0)
			$('.cpfIsValid').hide()
			$('#next').hide()
			$cpf.addClass('is-invalid')
		})
	})
	$('form[action*=verifyParticipant] #passport').off('change.validate').on('change.validate', function () {
		axios.post('verifyPassport', { passport: this.value }).then(function ({ data: { exists } }) {
			$('.cpfIsValid').toggle(exists)
			$('#next').show()
			$('#isCpfValid').val(exists ? 1 : 0)
		}).catch(function (error) {
			console.log(error)
			$('#isCpfValid').val(0)
			$('.cpfIsValid').hide()
			$('#next').hide()
		})
	})
})

function init() {
	const $cpf = document.getElementById('cpf')
	const $rg = document.getElementById('rg')
	const $dateBirth = document.getElementById('dataNascimento')
	const $primaryPhone = document.getElementById('telefonePrincipal')
	const $secondaryPhone = document.getElementById('telefoneSecundario')
	const $errorModal = document.getElementById('errorModal')

	if ($cpf != null) Inputmask({ mask: '999.999.999-99' }).mask($cpf)
	if ($rg != null) Inputmask({ mask: '99.999.999-*' }).mask($rg)
	if($dateBirth != null) Inputmask({mask: '99/99/9999'}).mask($dateBirth)

	$('#dataNascimento').daterangepicker({
		locale: {
			format: "DD/MM/YYYY",
			separator: " - ",
			applyLabel: "Aplicar",
			cancelLabel: "Cancelar",
			fromLabel: "De",
			toLabel: "Para",
			customRangeLabel: "Range customizado",
			weekLabel: "S",
			daysOfWeek: ["D", "S", "T", "Q", "Q", "S", "S"],
			monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
			firstDay: 0
		},
		autoApply: true,
		showDropdowns: true,
		singleDatePicker: true
	}, function (start, end) {
		dateBirth = start.format('YYYY-MM-DD')
	})

	if ($primaryPhone != null) {
		let iti = intlTelInput($primaryPhone, { hiddenInput: 'primaryPhone', ...configIntlTelInput })
		let inputmask = Inputmask().mask($primaryPhone)
		$($primaryPhone).off('keydown').on('keydown', function () {
			inputmask.option('mask')
			// Inputmask(this.getAttribute('placeholder').replace(/\d/g, '9')).mask($primaryPhone)
		})
	}
	if ($secondaryPhone != null) {
		intlTelInput($secondaryPhone, { hiddenInput: 'secondaryPhone', ...configIntlTelInput })
	}

	if ($errorModal != null) {
		const modal = new bootstrap.Modal($errorModal);
		modal.show();
	}
}
